/* tslint:disable */
/* eslint-disable */
/**
 * driverRegistration driver-registration-portal api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 *
 * //!!!! WARNING !!!!!!!!
 * //This is an auto generated file.
 * //Changes to this code will be lost if the code is regenerated.
 */

export interface AppPromotion {
    your_account_created: string;
    continue_registration_in_app: string;
    get_driver_app: string;
    driver_app_is_outdated: string;
    update_driver_app: string;
    please_download_app_text: string;
    you_can_login: string;
    download_on_google_play: string;
    download_on_app_store: string;
    scan_qr_code: string;
    or_use_links: string;
    continue_in_browser: string;
}
